module.exports = __webpack_public_path__ + "static/img/4983_phase_function_Paper_Points.7e62e56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4983_phase_function_Paper_Points.png
// module id = 9cAo
// module chunks = 0